import { dayToNumber, fileFormToUpdate, interestsToStr, monthToNumber } from '@/_containers';
import { emailsFromToUpdateConverter } from '@/_containers/inputs/emails/shared';
import { nullableStringToNullableIntConverter } from '@/_schemas/generic';
import { statusToStr } from '@/_schemas/status-input';
import { getUniqueRelationshipIds } from '@/_shared';

import type { ContactFormSchema, ContactUpdateSchema } from '../schemas';

export function contactFormToUpdate({
  birth_day,
  birth_month,
  work_anniversary,
  wedding_anniversary,
  interests,
  phone_numbers,
  profile_image,
  status,
  remote_worker,
  friends,
  contacts_associated_with: _,
  addresses,
  clients,
  primary_client,
  emails,
  freshdesk,
  ...rest
}: ContactFormSchema): ContactUpdateSchema {
  const relationshipInfo = getUniqueRelationshipIds({ main: clients || [], primary: primary_client || [] });

  const associatedContactIds = new Set<number>();
  (friends || []).forEach((item) => associatedContactIds.add(item.id));

  return {
    ...rest,
    birth_day: dayToNumber(birth_day),
    birth_month: monthToNumber(birth_month),

    // !important: the time is set to 00:00:00 to avoid audit issues
    work_anniversary: work_anniversary ? work_anniversary + ' 00:00:00' : null,
    wedding_anniversary: wedding_anniversary ? wedding_anniversary + ' 00:00:00' : null,

    interests: interestsToStr(interests),
    phone_numbers: phone_numbers?.map((item) => item.id) ?? [],
    status: statusToStr(status),
    profile_image: fileFormToUpdate(profile_image),
    remote_worker: parseInt(remote_worker, 10),
    addresses: addresses?.map((item) => item.id) ?? [],
    contacts_associated_with: Array.from(associatedContactIds),
    primary_client: relationshipInfo.primaryIds,
    alternate_clients: relationshipInfo.alternateIds,
    emails: emailsFromToUpdateConverter(emails),

    freshdesk: nullableStringToNullableIntConverter(freshdesk),
  };
}
